<template>
    <KForm
        id="login"
        @submit="submit"
        @cancel="cancel"
        :errors="errors"
        :schema="BasicLoginSchema"
        :submit-content="submitButton"
        cancel-content="Avbryt"
    />
</template>

<script setup>
    import { toRefs } from "vue";
    import KForm from "@/components/forms/Form/KForm.vue";
    import BasicLoginSchema from "@/components/Auth/formSchemas/BasicLoginSchema";

    const props = defineProps({
        errors: {
            type: Object,
            default: () => ({}),
        },
        submitButton: {
            type: String,
            default: "Logga in",
        },
    });

    const { errors, submitButton } = toRefs(props);

    const emit = defineEmits(["submit", "cancel"]);

    const submit = async (formData) => {
        emit("submit", formData);
    };

    const cancel = () => {
        emit("cancel");
    };
</script>
